module.exports = __webpack_public_path__ + "static/media/sitemap.ea5fe389.xml";